/**
 * Descrierea unui nivel de premiere, rupta in lista.
 *
 * `descriere` o scrie ECOTIC din `/admin/niveluri-tichete` (max 1000 de caractere, `TicketTierDTO`) si e
 * SURSA DE ADEVAR pentru ce recompense se vad. Nu se hardcodeaza nicio lista in componenta, pentru doua
 * motive: continutul e al clientului (trebuie sa-l poata schimba fara deploy), iar `couponValue` NU poate
 * tine locul listei — e o singura cifra, iar un nivel poate da „card cadou SAU lectie online SAU laptop".
 *
 * Modul PUR, fara React: vitest ruleaza pe `environment: node`, fara jsdom, deci in proiect nu exista
 * teste de componenta. Ce nu ajunge aici nu e acoperit de nicio poarta automata.
 */

/**
 * Marcaj de lista scris de admin la inceputul unei linii. Se SCOATE, fiindca randul primeste bullet-ul
 * lui: altfel ecranul ar arata „• - Card cadou 200 lei".
 *
 * Doar marcaje, nu si numerotare — la „1. Card cadou" cifra e continut, nu decor.
 */
const MARCAJ = /^[-•*–—]\s+/;

/**
 * Liniile descrierii, grupate. O linie goala (sau doar cu spatii) desparte grupurile; liniile goale de
 * la capete nu produc grupuri goale.
 *
 * `[]` pentru `null` / `undefined` / text gol: cardul nu randeaza nicio lista si nu inventeaza text.
 */
export function grupuriDescriere(descriere: string | null | undefined): string[][] {
    if (!descriere) return [];

    const grupuri: string[][] = [];
    let curent: string[] = [];
    const inchide = () => {
        if (curent.length > 0) {
            grupuri.push(curent);
            curent = [];
        }
    };

    for (const bruta of descriere.split(/\r?\n/)) {
        const linie = bruta.trim();
        if (!linie) {
            inchide();
            continue;
        }
        const text = linie.replace(MARCAJ, '').trim();
        // O linie care e DOAR un marcaj nu are ce afisa; se citeste ca separator, ca o linie goala.
        if (!text) {
            inchide();
            continue;
        }
        curent.push(text);
    }

    inchide();
    return grupuri;
}

/**
 * Regula afisata sub grila de niveluri.
 *
 * 🔴 NU spune „premiile nu sunt cumulative" — fraza din pptx-ul clientului contrazice decizia owner-ului
 * din 2026-09-19. Ce e adevarat pe platforma: o recompensa pe nivel (`max_per_school = 1` pe toate cele
 * cinci trepte), apoi se pot strange puncte din nou pentru nivelul urmator.
 */
export const REGULA_PREMII =
    'O singură recompensă pe nivel. După ce o primești, poți strânge puncte din nou pentru nivelul următor.';

/**
 * Textul de subsol, sau `null` cand nu exista niveluri.
 *
 * Decizia „se randeaza sau nu" sta AICI, nu in componenta: un text de regulament sub o grila goala
 * sugereaza ca lipseste ceva, iar in `.tsx` nu l-ar pazi nicio poarta automata.
 */
export function subsolPremii(numarNiveluri: number): string | null {
    return numarNiveluri > 0 ? REGULA_PREMII : null;
}
